module.exports = __webpack_public_path__ + "static/media/claims-icon-green.40ce7262.svg";